import React, { useState } from 'react';

import Collapse from 'common/components/core/Collapse/Collapse';

import './OfflineStateMessage.scss';

export default function OfflineStateMessage() {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div className="offline-state-message">
      <div className="offline-state-message__content">
        <h2 className="offline-state-message__title">You are offline</h2>
        <div className="mt-m">It seems there is a problem with your internet connection.</div>

        <Collapse className={expanded ? 'mt-m' : ''} isOpen={expanded}>
          This can occur either because your network connection is unstable or because NC2 backplane is experiencing
          network or other issues. Please check your internet connection, if the problem persists contact your
          administrator.
        </Collapse>

        <div
          role="button"
          className="offline-state-message__action mt-m"
          onClick={() => setExpanded(!expanded)}
          tabIndex={0}
        >
          {expanded ? 'Show less' : 'Show more'}
        </div>
      </div>
    </div>
  );
}
